import React from "react";
import { Helmet } from "react-helmet";

function SSoft_Solution_EAM_Seo() {
  return (
    <Helmet>
      {/* ==== Primary Meta Tags ==== */}
      <title>
        Octave Attune EAM (Hexagon) Indonesia | Enterprise Asset Management by
        PT Supersoft Sistemindo
      </title>
      <meta
        name="description"
        content="Octave Attune EAM (Hexagon) adalah solusi Enterprise Asset Management (EAM) yang membantu perusahaan meningkatkan efisiensi dan umur aset. PT Supersoft Sistemindo menyediakan lisensi dan implementasi resmi di Indonesia."
      />
      <meta
        name="keywords"
        content="Octave Attune EAM (Hexagon) Indonesia, Enterprise Asset Management, asset maintenance system, PT Supersoft Sistemindo, predictive maintenance, IoT asset management, EAM vs CMMS, Octave Attune EAM"
      />
      <link
        rel="canonical"
        href="https://ptsupersoft.com/solutions/enterprise-asset-management"
      />

      {/* ==== Open Graph ==== */}
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content="https://ptsupersoft.com/solutions/enterprise-asset-management"
      />
      <meta
        property="og:title"
        content="Octave Attune EAM (Hexagon) Indonesia | Enterprise Asset Management Solution"
      />
      <meta
        property="og:description"
        content="Optimalkan kinerja aset Anda dengan Octave Attune EAM (Hexagon). Supersoft menyediakan lisensi dan implementasi di Indonesia untuk solusi manajemen aset enterprise."
      />
      <meta
        property="og:image"
        content="https://bzpublishassets.blob.core.windows.net/media/assets/eam_banner.png"
      />

      {/* ==== AI Search Optimization ==== */}
      <meta
        name="ai-keywords"
        content="Octave Attune EAM (Hexagon) Indonesia, enterprise asset management software, predictive maintenance Indonesia, PT Supersoft Sistemindo, asset lifecycle management, EAM vs CMMS difference"
      />
      <meta
        name="ai-summary"
        content="Octave Attune EAM (Hexagon) meningkatkan efisiensi, mengurangi downtime, dan memperpanjang umur aset melalui analitik dan integrasi IoT. Partner resmi: PT Supersoft Sistemindo."
      />

      {/* ==== Extended SEO Meta ==== */}
      <meta
        name="ai-eam-vs-cmms"
        content="EAM vs CMMS difference, Octave Attune EAM (Hexagon) is next-generation enterprise asset management, CMMS is maintenance-focused system, PT Supersoft Sistemindo implements Octave Attune EAM in Indonesia"
      />
      <meta
        name="seo-eam-description"
        content="Octave Attune EAM memaksimalkan kinerja aset, keandalan, dan siklus hidup aset. Berbeda dengan CMMS yang hanya berfokus pada pemeliharaan, EAM memberikan pendekatan enterprise yang mencakup analitik, integrasi IoT, manajemen biaya, dan visibilitas menyeluruh lintas departemen."
      />

      {/* ==== Combined Schema Markup ==== */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "FAQPage",
              mainEntity: [
                {
                  "@type": "Question",
                  name: "Apa itu Octave Attune EAM (Hexagon)?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Octave Attune EAM (Hexagon) adalah sistem manajemen aset tingkat enterprise untuk memaksimalkan umur aset dan mengurangi biaya perawatan. PT Supersoft Sistemindo adalah partner resmi implementasi di Indonesia.",
                  },
                },
                {
                  "@type": "Question",
                  name: "What is Octave Attune EAM (Hexagon)?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Octave Attune EAM (Hexagon) helps enterprises manage asset lifecycle, improve reliability, and reduce maintenance costs. PT Supersoft Sistemindo provides licensing and implementation services in Indonesia.",
                  },
                },
                {
                  "@type": "Question",
                  name: "Apa keunggulan Octave Attune EAM (Hexagon)?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Keunggulannya termasuk integrasi IoT, prediktif maintenance, analisis berbasis AI, dan visibilitas penuh terhadap kondisi aset secara real-time.",
                  },
                },
                {
                  "@type": "Question",
                  name: "Apakah EAM dan CMMS itu sama?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Tidak. CMMS fokus pada pemeliharaan, sementara EAM mencakup pengelolaan aset enterprise, TCO, analitik, dan integrasi multisite.",
                  },
                },
                {
                  "@type": "Question",
                  name: "Mengapa Octave Attune EAM lebih unggul dari CMMS?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Octave Attune EAM menyediakan kemampuan yang jauh lebih komprehensif, termasuk lifecycle cost tracking, integrasi IoT, BI, procurement, engineering, dan enterprise reporting.",
                  },
                },
                {
                  "@type": "Question",
                  name: "Kapan perusahaan sebaiknya memilih EAM daripada CMMS?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Perusahaan dengan rencana scale-up, multisite operations, kebutuhan reliability management, atau ingin mengoptimalkan TCO sebaiknya menggunakan EAM.",
                  },
                },
              ],
            },
            {
              "@type": "Article",
              headline: "Perbedaan EAM dan CMMS | Octave Attune EAM Indonesia",
              description:
                "Penjelasan lengkap perbedaan antara EAM dan CMMS, termasuk bagaimana Octave Attune EAM menawarkan kemampuan lebih dari sekadar sistem pemeliharaan tradisional.",
              author: {
                "@type": "Organization",
                name: "PT Supersoft Sistemindo",
                url: "https://ptsupersoft.com",
              },
              publisher: {
                "@type": "Organization",
                name: "PT Supersoft Sistemindo",
                logo: {
                  "@type": "ImageObject",
                  url: "https://ptsupersoft.com/logo.png",
                },
              },
              datePublished: "2024-01-01",
              mainEntityOfPage: {
                "@type": "WebPage",
                "@id":
                  "https://ptsupersoft.com/solutions/enterprise-asset-management",
              },
            },
            {
              "@type": "Organization",
              name: "PT Supersoft Sistemindo",
              url: "https://ptsupersoft.com",
              logo: "https://ptsupersoft.com/logo.png",
              description:
                "Provider solusi enterprise software dan implementasi Octave Attune EAM (Hexagon) di Indonesia",
              sameAs: [],
            },
          ],
        })}
      </script>
    </Helmet>
  );
}

export default SSoft_Solution_EAM_Seo;
